// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22L22 2ZM15.75 9.5C15.75 11.5711 14.0711 13.25 12 13.25C9.92893 13.25 8.25 11.5711 8.25 9.5C8.25 7.42893 9.92893 5.75 12 5.75C14.0711 5.75 15.75 7.42893 15.75 9.5ZM5 19.5018C5 17.0166 7.01472 15.0018 9.5 15.0018H14.5C16.9853 15.0018 19 17.0166 19 19.5018V20.0018H5V19.5018Z"}}]};

const UserAvatarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-avatar-filled',
    ref,
    icon: element,
  },
));

UserAvatarFilledIcon.displayName = 'UserAvatarFilledIcon';

export default UserAvatarFilledIcon;
